



/**  
 * Include your custom JavaScript here. 
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */



$(document).ready(function () {
  function checkAndModifyForm() {
    var searchanise_form = $('.search-bar__input-wrapper form[action="/pages/search-results-page"]');
    
    if (searchanise_form.length > 0) {
      searchanise_form.attr('action', '/search');

      clearInterval(intervalId);
    }
  }

  var intervalId = setInterval(checkAndModifyForm, 1000); 
});

  if (window.location.pathname === '/pages/search-results-page') {
    var searchParams = new URLSearchParams(window.location.search);
    var qValue = searchParams.get('q');

    if (qValue) {
      window.location.href = '/search?q=' + encodeURIComponent(qValue);
    }
  }



$(document).ready(function () {

  var searchanise_form = $('.search-bar__input-wrapper > form[action="/pages/search-results-page"]');
  $(searchanise_form).attr('action', '/search')

  $('#clear_cart').on('click', function (e) {

    e.preventDefault();
    window.location = '/cart/clear';

  })


  $('body').on('click', 'button.search-bar__submit', function (e) {

    var searchanise_form = $('.search-bar__input-wrapper > form[action="/pages/search-results-page"]');

    $(searchanise_form).attr('action', '/search')
    $(searchanise_form).submit()



  });



  $('body').removeClass('snize-warehouse-css-fix')


  $('#toggle-id2').on('change', function () {
    var vat = $(this).prop('checked')

    //CartJS.setAttribute('vat', vat);


    $.ajax({
      url: "/cart",
      data: "attributes[vat]=" + vat,
      type: "POST",
      dataType: "text"
    });


    Cookies.set('vat', vat)
    setTimeout(function () {
      window.location = window.location
    }, 400)

  })

  var vat = Cookies.get('vat')

  if (vat == 'true') {
    $('#toggle-id2').prop('checked', 'checked')
    $('body').addClass('vattrue')
    // CartJS.setAttribute('vat', true);

    $.ajax({
      url: "/cart",
      data: "attributes[vat]=true",
      type: "POST",
      dataType: "text"
    });


  } else {
    $('body').addClass('vatfalse')

    $.ajax({
      url: "/cart",
      data: "attributes[vat]=false",
      type: "POST",
      dataType: "text"
    });


    // CartJS.setAttribute('vat', false);

  }




  $('#close_announcement2').on('click', function () {
    Cookies.set('close_announcement2', 'true')
    $('.announcement-bar2').slideUp()
  })

  var ann = Cookies.get('close_announcement2')
  if (ann == 'true') {
  } else {
    $('.announcement-bar2').slideDown()
  }




  $('#qty_up').on('click', function () {
    var current_qty = $('#qty__input').val()
    var next_qty = parseInt(current_qty) + 1
    $('#qty__input').val(next_qty).trigger('change').attr('value', next_qty)


  })
  $('#qty_down').on('click', function () {
    var current_qty = $('#qty__input').val()
    var next_qty = parseInt(current_qty) - 1
    if (next_qty > 0) {
      $('#qty__input').val(next_qty).trigger('change').attr('value', next_qty)

    }
  })






})


function convertToIncVat(price, element, multiplier) {

  var m = multiplier || 1.20;

  price = price.replace('£', '').replace(' GBP', '')
  price = (price * m).toFixed(2)
  price = '£' + price + ' <span class="n_incvat">INC VAT</span>'
  element.html(price)

}

function convertToExVat(price, element, multiplier) {

  var m = multiplier || 1.00;

  price = price.replace('£', '').replace(' GBP', '')
  price = (price * m).toFixed(2)
  price = '£' + price + ' <span class="n_exvat">EX VAT</span>'
  element.html(price)

}

$('body').on('change', 'select#search-product-collection', function () {

  var sc = $(this).find('option:selected').val();
  var sc2 = sc.replaceAll(' ', '+')
  var label = $(this).siblings('label').find('span')

  $(label).html(sc)

  Cookies.set('search_collection', sc2)

})




$('body').on('click', '#shopify-section-page_template .layout__section--secondary .card__section--tight > .collection__filter-linklist > li', function () {

  var isOpen = ($(this).hasClass('open'));

  if (isOpen) {
    $(this).removeClass('open')
  } else {
    $(this).addClass('open')
  }

})



$(window).on('load', function () {





  $('input.product-form__quantity.search-bar__input').on('change keyup', function () {

    var q = $(this).val()
    if (q == '') {
    } else {
      if (q == 0) {
        $(this).val(1)
      } else {
        updatePrices()
      }
    }

  })


  function dynamicPrices() {

    var running_total = 0.00;
    var original_price = $('[data-op-ex-price]').attr('data-op-ex-price')
    var qty = parseFloat($('input.product-form__quantity.search-bar__input').val())
    var vatrate = 1.0;
    var vatsuffix = '';

    var vat = Cookies.get('vat')

    if (vat == 'true') {
      vatrate = 1.2;
      vatsuffix = ' <span class="n_incvat">INC VAT</span>'
    }


    var quantity_tiers = $("body.template-product #product_bulk_table").length
    var quantity_table = $("body.template-product #product_bulk_table")

    if (quantity_tiers > 0) {


      var tierunit1 = parseInt($(quantity_table).attr('data-tierunit1'))
      var tierpercent1 = parseInt($(quantity_table).attr('data-tierpercent1'))

      var tierunit2 = parseInt($(quantity_table).attr('data-tierunit2'))
      var tierpercent2 = parseInt($(quantity_table).attr('data-tierpercent2'))

      var tierunit3 = parseInt($(quantity_table).attr('data-tierunit3'))
      var tierpercent3 = parseInt($(quantity_table).attr('data-tierpercent3'))

      var fprice = original_price * qty;

      if (qty >= tierunit3) {
        fprice = $(quantity_table).find('[data-tierprice1]').attr('data-tierprice1') * qty;
      } else if (qty >= tierunit2) {
        fprice = $(quantity_table).find('[data-tierprice2]').attr('data-tierprice2') * qty;
      } else if (qty >= tierunit1) {
        fprice = $(quantity_table).find('[data-tierprice3]').attr('data-tierprice3') * qty;
      }


      running_total = '£' + ((fprice * vatrate) / 100.00).toFixed(2) + vatsuffix;

      $('.price-list > .price').html(running_total)

    } else {

      var noqty_total = '£' + ((original_price * qty * vatrate) / 100).toFixed(2) + vatsuffix;


      running_total = noqty_total;

    }





  }


  function updatePrices() {

    var running_total = 0.00;


    var original_price_element = $('[data-op-ex-price]')
    var original_price = parseFloat($(original_price_element).attr('data-op-ex-price'))

    console.log(original_price)

    var qty = parseFloat($('input.product-form__quantity.search-bar__input').val())
    var vatrate = 1.0;
    var vatsuffix = '';

    var vat = Cookies.get('vat')

    if (vat == 'true') {
      vatrate = 1.2;

      vatsuffix = ' <span class="n_incvat">INC VAT</span>'
    }
    var qtyexvat_price = '£' + ((original_price * qty * vatrate) / 100).toFixed(2) + vatsuffix;


    var quantity_tiers = $("body.template-product #product_bulk_table").length
    var quantity_table = $("body.template-product #product_bulk_table")

    if (quantity_tiers > 0) {

      var savings = 0;

      var tierunit1 = parseInt($(quantity_table).attr('data-tierunit1'))
      var tierpercent1 = parseFloat($(quantity_table).attr('data-tierpercent1'))

      var tierunit2 = parseInt($(quantity_table).attr('data-tierunit2'))
      var tierpercent2 = parseFloat($(quantity_table).attr('data-tierpercent2'))

      var tierunit3 = parseInt($(quantity_table).attr('data-tierunit3'))
      var tierpercent3 = parseFloat($(quantity_table).attr('data-tierpercent3'))


      if (qty >= tierunit3) {
        savings = (original_price * tierpercent3) / 100.00
      } else if (qty >= tierunit2) {
        savings = (original_price * tierpercent2) / 100.00
      } else if (qty >= tierunit1) {
        savings = (original_price * tierpercent1) / 100.00
      }


      running_total = '£' + (((original_price - savings) * qty * vatrate) / 100.00).toFixed(2) + vatsuffix;




      $('.price-list > .price').html(running_total)

    } else {

      var noqty_total = '£' + ((original_price * qty * vatrate) / 100).toFixed(2) + vatsuffix;


      running_total = noqty_total;


    }




    $(original_price_element).html(running_total)



  }







  var vat = Cookies.get('vat')

  if (vat == 'true') {
    $('#shopify-section-product-template .price-list .price').each(function () {
      var ex = $(this).text()
      convertToIncVat(ex, $(this), 1.0)
    })

    $('.product-item__price-list.price-list .price').each(function () {
      var ex = $(this).text()
      convertToIncVat(ex, $(this))
    })


  } else {
    $('#shopify-section-product-template .price-list .price').each(function () {
      var ex = $(this).text()
      convertToExVat(ex, $(this))
    })

    $('.product-item__price-list.price-list .price').each(function () {
      var ex = $(this).text()
      convertToExVat(ex, $(this))
    })

  }


  $('body').removeClass('snize-warehouse-css-fix')


  $('ul.snize-product-filters-list').each(function () {


    var parentTitle = $(this).siblings('.snize-product-filters-title').find('span').text()

    if (parentTitle.indexOf("(") >= 0) {
      var newTitle = parentTitle.split('(')
      $(this).siblings('.snize-product-filters-title').find('span').text(newTitle[0])

    }

    var listItems = $(this).children('li')
    var title = $(this).parent().children('.snize-product-filters-title')
    var hide = true;

    listItems.each(function () {
      if ($(this).hasClass('snize-disabled')) {
      } else {
        hide = false;
      }
    })

    if (hide) {
      $(this).hide()
      title.hide()
    }


  })






})



$(document).on('cart.requestComplete', function (event, cart) {



  document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
    bubbles: true
  }));

  $('a.header__action-item-link.header__cart-toggle[data-action="toggle-mini-cart"]').attr('aria-expanded', 'true')
  $('a.header__action-item-link.header__cart-toggle[data-action="toggle-mini-cart"] + form#mini-cart').attr('aria-hidden', 'false')
  $('body').addClass('no-mobile-scroll')



});




